var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    { ref: "aside", staticClass: "aside-box" },
    [
      !_vm.specialChannel
        ? _c(
            "el-menu",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticClass: "el-menu-vertical-demo",
              class: { collapse: _vm.isCollapse },
              attrs: {
                "default-active": _vm.defaultActive,
                "unique-opened": false,
                router: false,
                collapse: _vm.isCollapse,
                "default-openeds": _vm.defaultOpened
              },
              on: {
                open: _vm.handleOpen,
                close: _vm.handleClose,
                select: _vm.handleSelect
              }
            },
            [
              _vm._l(_vm.menuList, function(item, index) {
                return [
                  !item.hidden
                    ? [
                        item.children && item.children.length > 0
                          ? _c(
                              "el-submenu",
                              {
                                key: index,
                                attrs: {
                                  index: "" + item.menuId,
                                  "popper-class": "pop-submenu"
                                }
                              },
                              [
                                _c("template", { slot: "title" }, [
                                  _c("i", {
                                    staticClass: "iconfont",
                                    class: item.icon
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { attrs: { slot: "title" }, slot: "title" },
                                    [_vm._v(_vm._s(item.menuName))]
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(item.children, function(child, index) {
                                  return [
                                    child.menuName.length > 100
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            key: child.url + "_" + index,
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            !child.hidden
                                              ? _c(
                                                  "el-menu-item",
                                                  {
                                                    key:
                                                      child.url + "_" + index,
                                                    attrs: { index: child.url }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(
                                                          child.menuName ||
                                                            child.name
                                                        ) +
                                                        "\n              "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content"
                                              },
                                              [_vm._v(_vm._s(child.menuName))]
                                            )
                                          ],
                                          1
                                        )
                                      : _c(
                                          "el-menu-item",
                                          {
                                            key: child.url + "_" + index,
                                            attrs: { index: child.url }
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  child.menuName || child.name
                                                ) +
                                                "\n            "
                                            )
                                          ]
                                        )
                                  ]
                                })
                              ],
                              2
                            )
                          : _c(
                              "el-menu-item",
                              { key: index, attrs: { index: item.url } },
                              [
                                [
                                  _c("div", { staticClass: "single-menu" }, [
                                    _c("i", {
                                      staticClass: "iconfont",
                                      class: item.icon
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "title" },
                                        slot: "title"
                                      },
                                      [_vm._v(_vm._s(item.menuName))]
                                    )
                                  ])
                                ]
                              ],
                              2
                            )
                      ]
                    : _vm._e()
                ]
              })
            ],
            2
          )
        : _vm._l(_vm.menuList, function(item) {
            return _c(
              "div",
              { key: item.menuId, staticClass: "menu-template" },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.menuName,
                        expression: "item.menuName"
                      }
                    ],
                    staticClass: "channel-title"
                  },
                  [_vm._v(_vm._s(item.menuName))]
                ),
                _vm._v(" "),
                _c(
                  "el-menu",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "el-menu-channel",
                    class: { collapse: _vm.isCollapse },
                    attrs: {
                      "default-active": _vm.defaultActive,
                      "unique-opened": false,
                      router: false,
                      collapse: _vm.isCollapse,
                      "default-openeds": _vm.defaultOpened
                    },
                    on: {
                      open: _vm.handleOpen,
                      close: _vm.handleClose,
                      select: _vm.handleSelect
                    }
                  },
                  [
                    _vm._l(item.children, function(item, index) {
                      return [
                        !item.hidden
                          ? [
                              item.children && item.children.length > 0
                                ? _c(
                                    "el-submenu",
                                    {
                                      key: index,
                                      attrs: {
                                        index: "" + item.menuId,
                                        "popper-class": "pop-submenu"
                                      }
                                    },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _c("i", {
                                          staticClass: "iconfont",
                                          class: item.icon
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "title" },
                                            slot: "title"
                                          },
                                          [_vm._v(_vm._s(item.menuName))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(item.children, function(
                                        child,
                                        index
                                      ) {
                                        return [
                                          child.menuName.length > 100
                                            ? _c(
                                                "el-tooltip",
                                                {
                                                  key: child.url + "_" + index,
                                                  staticClass: "item",
                                                  attrs: {
                                                    effect: "dark",
                                                    placement: "top"
                                                  }
                                                },
                                                [
                                                  !child.hidden
                                                    ? _c(
                                                        "el-menu-item",
                                                        {
                                                          key:
                                                            child.url +
                                                            "_" +
                                                            index,
                                                          attrs: {
                                                            index: child.url
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                child.menuName ||
                                                                  child.name
                                                              ) +
                                                              "\n                "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        slot: "content"
                                                      },
                                                      slot: "content"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(child.menuName)
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _c(
                                                "el-menu-item",
                                                {
                                                  key: child.url + "_" + index,
                                                  attrs: { index: child.url }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        child.menuName ||
                                                          child.name
                                                      ) +
                                                      "\n              "
                                                  )
                                                ]
                                              )
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                : _c(
                                    "el-menu-item",
                                    { key: index, attrs: { index: item.url } },
                                    [
                                      [
                                        _c("i", {
                                          staticClass: "iconfont",
                                          class: item.icon
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "title" },
                                            slot: "title"
                                          },
                                          [_vm._v(_vm._s(item.menuName))]
                                        )
                                      ]
                                    ],
                                    2
                                  )
                            ]
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              ],
              1
            )
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3eca7188", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eca7188","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideBar.vue
// module id = null
// module chunks = 